import {Icon, Select} from 'antd';
import * as React from 'react';
import {WithId} from './utils';
import locales from '../locales';
import {isNotBlank} from "./string-utils";

export const formItemLayout = {
  labelCol: {
    xs: {span: 24},
    sm: {span: 8},
  },
  wrapperCol: {
    xs: {span: 24},
    sm: {span: 16},
  },
};

export const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

export const emailSuffix = (email: string | undefined | null) => email ? (
  <a href={`mailto:${email}`} title={locales.send_email}>
    <Icon type="mail"/>
  </a>
) : null;

export const phoneSuffix = (phone: string | undefined | null) => phone ? (
  <a href={`tel:${phone}`} title={locales.initiate_call}>
    <Icon type="phone"/>
  </a>
) : null;

interface AddressParts {
  zip: string;
  city: string;
  address: string;
}

export const toCombinedAddress = (parts: AddressParts): string => `${parts.zip} ${parts.city}, ${parts.address}`;

export const addressSuffix = (address: string | undefined | null) => address ? (
  <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
     target="_blank"
     title={locales.open_map}>
    <Icon type="environment"/>
  </a>
) : null;

export const renderOptions = <T extends WithId>(
  options: T[] | undefined,
  renderTitle: (opt: T) => React.ReactNode
): React.ReactNode[] | undefined => {
  return options && options.map(opt => (
    <Select.Option value={opt.id ? opt.id : undefined} key={String(opt.id)}>{renderTitle(opt)}</Select.Option>
  ));
};


const isEmpty = (val: any) => val === undefined || val === null;

/**
 * If val1 or val2 is undefined don't report error.
 * If both has values report error if val1 not >= val2.
 */
export const gteOrEmptyValidator = (val1: any, val2: any, callback: any) => {
  if (isEmpty(val1) || isEmpty(val2)) {
    return callback();
  }
  return val1 >= val2 ? callback() : callback(true);
};

/**
 * If val1 or val2 is undefined don't report error.
 * If both has values report error if val1 not <= val2.
 */
export const lteOrEmptyValidator = (val1: any, val2: any, callback: any) => {
  if (isEmpty(val1) || isEmpty(val2)) {
    return callback();
  }
  return val1 <= val2 ? callback() : callback(true);
};

/**
 * If value is undefined or null or contains just whitespaces, then report error.
 */
export const notBlankValidator = (value: any, callback: any) => {
  if (isNotBlank(value)) {
    return callback();
  }
  return callback(true);
};


// WEBPACK FOOTER //
// ./src/utils/form-utils.tsx